export default "__VITE_ASSET__B8MlQO36__"